import { useMemo } from 'react';

import { TextButton } from '@zillow/constellation-10';

import { useSelector } from '../../selectors/useSelector';

import SelectPropertyConstants from '../../constants/SelectPropertyConstants';

import selectPropertyUtils from '../../utils/selectPropertyUtils';

import { VERTICAL_DISPLAY_TYPE } from '../../constants/PropertiesConstants';

import ConnectedApplications from '../ConnectedApplications';
import ConnectedModuleCard from '../../components/ConnectedModuleCard';

import { TRIGGER_LOCATIONS } from '../../constants/ClickstreamConstants';

const ApplicationsModule = () => {
  const listingAlias = useSelector((state) => state.properties.currentProperty.listingAlias);
  const applicationsPath = selectPropertyUtils.getPathByType(
    SelectPropertyConstants.APPLICATIONS as keyof typeof SelectPropertyConstants,
    listingAlias,
  );

  const renderCTA = useMemo(() => {
    return (
      <TextButton tone="brand" asChild>
        <a href={applicationsPath || ''} target="_self">
          Details
        </a>
      </TextButton>
    );
  }, [applicationsPath]);

  return (
    <ConnectedModuleCard
      data-testid="ApplicationsModule"
      title="Applications"
      ctaComponent={renderCTA}
      ctaFontType="body-sm"
      justifyHeadingContent={'center'}
      isLoading={false}
    >
      <ConnectedApplications
        displayType={VERTICAL_DISPLAY_TYPE.SIMPLE}
        triggerLocation={TRIGGER_LOCATIONS.PROPERTY_OVERVIEW}
      />
    </ConnectedModuleCard>
  );
};

export default ApplicationsModule;
